import { TableProps, Tag, Dropdown } from 'antd';
import { Category } from '@/types/categories/category';
import { CategoryModal } from '@/features/categories/utils/enums';

export const CategoryColumn = (
  setCurrentCategory: (category: Category) => void,
  setOpenModal: (modal: CategoryModal) => void,
  getCategoryMenu: (t: any, setOpenModal: any) => any,
  t: any,
): TableProps<Category>['columns'] => {
  return [
    {
      title: t('home.categories.table.nameColumn'),
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '30%',
      render: (text: string, record: Category) => (
        <span>
          {text}
          {!!record.default && (
            <Tag color="blue" style={{ marginLeft: 8 }}>
              {t('home.categories.table.default')}
            </Tag>
          )}
        </span>
      ),
    },
    {
      title: t('home.categories.table.statusColumn'),
      dataIndex: 'enabled',
      key: 'enabled',
      width: '15%',
      render: (enabled: boolean | null | undefined) => {
        const isEnabled = enabled ?? false;
        return (
          <Tag color={isEnabled ? 'green' : 'red'}>
            {isEnabled
              ? t('home.categories.table.enabled')
              : t('home.categories.table.disabled')}
          </Tag>
        );
      },
    },
    {
      title: t('home.categories.table.actionColumn'),
      key: 'action',
      width: '20%',
      render: (_: any, record: Category) => (
        <Dropdown menu={getCategoryMenu(t, setOpenModal)} trigger={['click']}>
          <a
            onClick={e => {
              e.stopPropagation();
              setCurrentCategory(record);
            }}
          >
            <img
              alt=""
              width={20}
              height={20}
              src={'/icons/more_action.svg'}
              style={{ color: 'blue' }}
            />
          </a>
        </Dropdown>
      ),
    },
  ];
};
